import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { PieChart, Pie, Cell, ResponsiveContainer as PieResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import Swal from 'sweetalert2';

const AnalyticsDashboard = () => {
    const [files, setFiles] = useState([]); // List of files
    const [selectedFile, setSelectedFile] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [scanData, setScanData] = useState(null);
    const [id, setId]=useState()
    const [selectedFiles, setSelectedFiles] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
    const userId = sessionStorage.getItem('userId');

    const containerStyle = {
        maxWidth: '1200px',
        width: '100%',

        margin: '0 auto',
        padding: '1px',
        fontFamily: 'Arial, sans-serif',
    };


  const headerStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#475569',
    color: '#fff',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width:'100%'
  };
    const titleStyle = {
        fontSize: '26px',
        fontWeight: 'bold',
        marginBottom: '10px',
        textAlign:'center'
    };

    const selectContainerStyle = {
        display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginTop: '20px',
    };
const containerStyle1 = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    gap: '20px',
  };
    const layoutStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '20px',
        flexWrap: 'wrap',
        flexDirection: isMobile ? 'column' : 'row',
    };

    const boxStyle = {
        flex: 1,
        maxWidth: isMobile ? '100%' : '50%',
    };
  const chartStyle = {
    flex: 1,
    marginRight: isMobile ? 0 : '20px',
  };
    const selectStyle = {
        padding: '8px',
        fontSize: '16px',
        width: '35%',
        height: '40px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        marginLeft: '10px',
        marginRight: '10px',
        minWidth: '200px',
width: '100%',
maxWidth: '350px',

    };

  const datePickerContainerStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'center',
    alignItems: isMobile ? 'flex-start' : 'center',
    gap: '10px',
    marginBottom: '10px',
  };

  const labelStyle = {
    marginBottom: isMobile ? '4px' : '0',
    fontWeight: 'bold',
  };

    const buttonStyle = {
        padding: '10px 10px',
        marginLeft: '20px',
        backgroundColor: '#0d6efd',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '10px',
      fontSize: '14px',
padding: '8px 16px',
width: 'auto',
height: 'auto'

    };

    const buttonHoverStyle = {
        backgroundColor: '#45a049',
    };

    const sectionStyle = {
        backgroundColor: '#fff',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '20px',
        marginBottom: '20px',
        borderRadius: '8px',
    };

    const sectionTitleStyle = {
        fontSize: '24px',
        fontWeight: '600',
        marginBottom: '20px',
        textAlign: 'center',
        color: '#333',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
    };

    const thStyle = {
        padding: '12px',
        textAlign: 'left',
        border: '1px solid #ddd',
        backgroundColor: '#f4f4f4',
    };

    const tdStyle = {
        padding: '12px',
        textAlign: 'left',
        border: '1px solid #ddd',
    };

    const trEvenStyle = {
        backgroundColor: '#f9f9f9',
    };

    // Fetch files on component mount
    useEffect(() => {
        axios.get(`https://qrapi.emedha.in/filetype-rowid/${userId}`)  // Example endpoint to get files for the user
            .then(response => {
                setFiles(response.data);
                console.log(response.data); 
                const allRowIds = response.data.map(file => file.rowId);
                setSelectedFiles(allRowIds); // Set all rowIds in the state
                console.log(allRowIds); 
            })
            .catch(error => console.error('Error fetching files:', error));
    }, []);

    // Handle file selection
    // const handleFileChange = (event) => {
    //     setSelectedFile(event.target.value);
        
    // };

    const handleFileChange = (event) => {
        const selectedRowId = event.target.value; // Get the selected rowId
        setSelectedFile(selectedRowId); // Update selected file state
        setId(selectedRowId); // Update the id state with the selected rowId
        console.log('Selected rowId:', selectedRowId); // You can log this to verify
    };

    // Handle date range selection
    const handleDateChange = (date, type) => {
        if (type === 'start') {
            setStartDate(date);
        } else {
            setEndDate(date);
        }
    };

    // Fetch scan data based on file selection and date range
    // const fetchScanData = () => {
    //     axios.get(`https://qrapi.emedha.in/api/scan-data/${id}`, {
    //         params: {
    //             startDate: startDate.toISOString(),
    //             endDate: endDate.toISOString(),
    //             userId:userId
    //         },
    //     })
    //         .then(response => {
    //             setScanData(response.data);
    //         })
    //         .catch(error => console.error('Error fetching scan data:', error));
    // };


const fetchScanData = () => {
  axios
    .get(`https://qrapi.emedha.in/api/scan-data/${id}`, {
      params: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        userId: userId,
      },
    })
    .then((response) => {
      setScanData(response.data);
    })
    .catch((error) => {
      if (error.response?.status === 403) {
        Swal.fire({
          icon: 'warning',
          title: 'Access Denied',
          text: error.response.data.error || 'Your free trial has expired.',
          confirmButtonText: 'Upgrade Now',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch scan data.',
        });
      }

      console.error('Error fetching scan data:', error);
    });
};

    const getDateRange = (start, end) => {
        const dates = [];
        const currentDate = new Date(start);
    
        while (currentDate <= end) {
            dates.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1); // Increment day by 1
        }
    
        return dates;
    };
    

    const getScanCountForDay = (day) => {
        const formattedDay = format(day, 'yyyy-MM-dd');
        const matchingDayData = scanData.scanCountData.find((entry) => format(new Date(entry.date), 'yyyy-MM-dd') === formattedDay);
        
        return matchingDayData ? matchingDayData.count : 0;
    };
    
    

    return (
        <div style={containerStyle}>
              <h1 style={titleStyle}>Analytics Dashboard</h1>
             <div style={headerStyle}>
              

                {/* File Selection */}
           
                    <label style={{ fontSize: '18px', marginRight: '10px' }}>Select File: </label>
                    <select style={selectStyle} onChange={handleFileChange} value={selectedFile}>
                        <option value="">Select File</option>
                        {files.map(file => (
                            <option key={file.rowId} value={file.rowId}>
                                {file.filename} QR Code
                            </option>
                        ))}
                    </select>
          
         
            {/* Date Range Selection */}
            <div style={datePickerContainerStyle}>
                <label>From: </label>
                <DatePicker selected={startDate} onChange={(date) => handleDateChange(date, 'start')} />
                <label>To: </label>
                <DatePicker selected={endDate} onChange={(date) => handleDateChange(date, 'end')} />
            </div>

            {/* Fetch Button */}
            <button style={buttonStyle} onClick={fetchScanData}>Get</button>
            </div>
            {/* Display the fetched analytics data */}
            {scanData && (
                <div>
                    {/* Scan Count Line Chart Section */}
                    <div style={sectionStyle}>
    <h3 style={sectionTitleStyle}>Scan Count Over Time</h3>
    
  <div style={containerStyle1}>
      {/* Scan Count Chart */}
      <div style={chartStyle}>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={scanData.scanCountData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tickFormatter={(tick) => format(new Date(tick), 'yyyy-MM-dd')} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="count" stroke="#8884d8" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Table for Days and Total Scans */}
      <div style={sectionStyle}>
        <h3 style={sectionTitleStyle}>Total Scans Per Day</h3>
        <table style={tableStyle}>
          <thead>
            <tr style={thStyle}>
              <th>Day</th>
              <th>Total Scans</th>
            </tr>
          </thead>
          <tbody>
            {getDateRange(startDate, endDate).map((day, index) => {
              const dayScanCount = getScanCountForDay(day);
              if (dayScanCount > 0) {
                return (
                  <tr key={index} style={index % 2 === 0 ? trEvenStyle : {}}>
                    <td style={tdStyle}>{format(new Date(day), 'yyyy-MM-dd')}</td>
                    <td style={tdStyle}>{dayScanCount}</td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      </div>
    </div>
</div>


                    {/* Device Distribution Section */}
    <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Device Distribution</h3>
            <div style={layoutStyle}>
                {/* Pie Chart */}
                <div style={boxStyle}>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={scanData.deviceData}
                                dataKey="count"
                                nameKey="deviceType"
                                outerRadius={80}
                                fill="#8884d8"
                                label
                            >
                                <Cell fill="#0d6efd" />
                                <Cell fill="#475569" />
                                <Cell fill="#ff0000" />
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>

                {/* Table */}
                <div style={boxStyle}>
                    <div style={{
                        marginTop: '20px',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '5px'
                    }}>
                        <h3>Device Type Scan Counts</h3>
                        <table style={tableStyle}>
                            <thead>
                                <tr style={{ backgroundColor: '#f4f4f4', textAlign: 'left' }}>
                                    <th style={thStyle}>Device Type</th>
                                    <th style={thStyle}>Scan Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {scanData.deviceData.map((device, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                                        <td style={tdStyle}>{device.deviceType}</td>
                                        <td style={tdStyle}>{device.count}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

                    {/* Location Table Section */}
                    <div style={sectionStyle}>
                        <h3 style={sectionTitleStyle}>Location Data</h3>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Country</th>
                                    <th style={thStyle}>Location</th>
                                    <th style={thStyle}>Scan Count</th>
                                </tr>
                            </thead>
<tbody>
  {scanData.locationData.map((location, index) => {
    let rawLocation = location.location;

    try {
      // First parse to convert to string
      const jsonString = JSON.parse(rawLocation); // yields: '{"country":"India","region":"Telangana","city":"Hyderabad"}'

      // Then parse again to convert to object
      const locationInfo = JSON.parse(jsonString);

      return (
        <tr key={index} style={index % 2 === 0 ? trEvenStyle : {}}>
          <td style={tdStyle}>{locationInfo.country}</td>
          <td style={tdStyle}>{locationInfo.region}</td>
          <td style={tdStyle}>{location.scanCount}</td>
        </tr>
      );
    } catch (error) {
      console.error("Failed to parse location:", rawLocation, error.message);
      return (
        <tr key={index}>
          <td colSpan="3" style={tdStyle}>Invalid Location Data</td>
        </tr>
      );
    }
  })}
</tbody>

                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};


export default AnalyticsDashboard;
